import { Tooltip } from "antd"
import { useTranslation } from "react-i18next"

const withPermission = (WrappedComponent, rolesAllowed) => {
  return ({ role, tooltip, ...props }) => {
    const { t } = useTranslation()
    const isAllowed = role ? rolesAllowed.includes(role) : true

    if (isAllowed) {
      return <WrappedComponent {...props} />
    }

    return (
      <Tooltip
        trigger={tooltip === false ? null : "hover"}
        title={t(
          "This action is restricted by your User Management settings for the current business account."
        )}
      >
        <div>
          <WrappedComponent {...props} disabled />
        </div>
      </Tooltip>
    )
  }
}

export default withPermission
